import React, { useEffect, useState } from "react";
import "./purchagedetails.css";
import Header from "../../components/Navbar";
import axios from "axios";
import closed from "../../myimgs/close.png";
import Swal from "sweetalert2";
import Check from "../../myimgs/check.png";

const PurchaseAndBidding = () => {
  const [purchaseRequests, setPurchaseRequests] = useState([]);
  const [biddingHistory, setBiddingHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedDetails, setSelectedDetails] = useState(null);
  const [showModal, setShowModal] = useState(false);

  // states for decision
  const [sellValue, setSellValue] = useState(null);
  const [winnerRaw, setWinnerRaw] = useState(null);
  const [winnerBool, setWinnerBool] = useState(false);
  const [propertyId, setPropertyId] = useState(null);

  const userId = localStorage.getItem("userId");
  useEffect(() => {
    const id = localStorage.getItem("selectedPropertyId");
    const sellValue = localStorage.getItem("sell");

    setPropertyId(id);
    console.log("Property ID:", id);
    console.log("Sell value:", sellValue);
  }, []);

  useEffect(() => {
    const fetchBidData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/bid/property-id/${propertyId}/user-id/${userId}`,
        );

        console.log("fetchBidData: full response:", response?.data);

        if (response.data && response.data.data) {
          const { bidHistory, purchesRequest } = response.data.data;
          setBiddingHistory(bidHistory || []);
          setPurchaseRequests(purchesRequest || []);

          // Try to find winner value in a few likely spots:
          let possibleWinner = undefined;

          // 1) direct field
          if (response.data.data.winner !== undefined) {
            possibleWinner = response.data.data.winner;
          }

          // 2) sometimes winner info could be inside a nested object (e.g., in an object named result or meta)
          if (
            possibleWinner === undefined &&
            response.data.data.result?.winner !== undefined
          ) {
            possibleWinner = response.data.data.result.winner;
          }

          // 3) maybe winner flagged inside bidHistory (find any bid with winner true)
          if (
            possibleWinner === undefined &&
            Array.isArray(bidHistory) &&
            bidHistory.length > 0
          ) {
            const winEntry = bidHistory.find(
              (b) =>
                b?.winner !== undefined &&
                (b.winner === true || b.winner === "true"),
            );
            if (winEntry) {
              possibleWinner = winEntry.winner;
            }
          }

          // 4) fallback: maybe API returns string "true"/"false" nested in data.data.winner
          // possibleWinner remains undefined if not found.

          console.log(
            "determined possibleWinner from response:",
            possibleWinner,
          );

          setWinnerRaw(possibleWinner);

          // normalize to boolean:
          const normalized =
            possibleWinner === true ||
            possibleWinner === "true" ||
            possibleWinner === "1" ||
            possibleWinner === 1;
          setWinnerBool(Boolean(normalized));
        } else {
          console.warn("Unexpected response structure:", response.data);
        }
      } catch (error) {
        console.error("Error fetching bid data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBidData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propertyId, userId]);

  // load sell value once and normalize
  useEffect(() => {
    const sellValueFromStorage = localStorage.getItem("sell");
    console.log("Sell value from localStorage (raw):", sellValueFromStorage);
    // Keep the raw string too (since you used "false"/"true"), but normalize boolean as well if you need
    setSellValue(sellValueFromStorage);
  }, []);

  const handleViewDetails = (buyer) => {
    setSelectedDetails(buyer);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedDetails(null);
  };

  // Confirm Buyer Flow
  //Common function for property confirmation
  const handlePropertyConfirmation = async () => {
    const baseUrl = process.env.REACT_APP_API_BASE_URL;

    const confirmResult = await Swal.fire({
      title: "Do you confirm this property as sold and remove from Twoffers?",
      showConfirmButton: true,
      showDenyButton: true,
      showCancelButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      confirmButtonText: "CONFIRM AS SOLD BUT KEEP MY LISTING IN TWOFFERS",
      denyButtonText: "CONFIRM AS SOLD AND REMOVE MY LISTING FROM TWOFFERS",
      confirmButtonColor: "#007bff",
      denyButtonColor: "#007bff",
      customClass: {
        popup: "purchase-alert",
        actions: "purchase-alert-actions",
        confirmButton: "purchase-alert-confirm",
        denyButton: "purchase-alert-deny",
      },
    });

    try {
      // If user clicks KEEP MY LISTING
      if (confirmResult.isConfirmed) {
        const response = await axios.put(
          `${baseUrl}/property/sell/${propertyId}`,
        );
        if (response.status === 200) {
          await Swal.fire({
            title: "Property Confirmed as Sold!",
            text: "Your listing will remain active on Twoffers.",
            icon: "success",
            confirmButtonColor: "#007bff",
          });
        }
      }

      //If user clicks REMOVE MY LISTING
      else if (confirmResult.isDenied) {
        const response = await axios.put(
          `${baseUrl}/property/remove-from-listing/${propertyId}`,
        );
        if (response.status === 200) {
          await Swal.fire({
            title: "Property Confirmed as Sold!",
            text: "Your listing has been removed from Twoffers.",
            icon: "success",
            confirmButtonColor: "#007bff",
          });
        }
      }
    } catch (error) {
      console.error("API error:", error);
      Swal.fire(
        "Error",
        "Something went wrong while processing request.",
        "error",
      );
    }
  };

  const handleMarkAsBuyer = async () => {
    if (!selectedDetails) return;

    const { name } = selectedDetails;
    const bidAmount = selectedDetails.bidAmount || 0;
    const baseUrl = process.env.REACT_APP_API_BASE_URL;

    const result = await Swal.fire({
      title: `Do you want to confirm ${name} as buyer of your property for CAD $${bidAmount}?`,
      showDenyButton: true,
      confirmButtonText: "YES",
      denyButtonText: "NO",
      confirmButtonColor: "#007bff",
      denyButtonColor: "#007bff",
      customClass: {
        popup: "purchase-alert",
        actions: "purchase-alert-actions",
        confirmButton: "purchase-alert-confirm",
        denyButton: "purchase-alert-deny",
      },
    });

    if (result.isConfirmed) {
      try {
        // 🟢 Step 1: Mark winner API call
        const response = await axios.put(
          `${baseUrl}/bid/mark-winner/property-id/${propertyId}/user-id/${userId}`,
        );

        if (response.status === 200) {
          // 🟢 Step 2: If success, then show property confirmation popup
          await handlePropertyConfirmation();
        } else {
          Swal.fire("Error", "Failed to mark buyer as winner.", "error");
        }
      } catch (error) {
        console.error("Error marking winner:", error);
        Swal.fire(
          "Error",
          "Something went wrong while marking winner.",
          "error",
        );
      }
    }
  };
  if (loading) {
    return (
      <>
        <Header />
        <div className="purchase-bid-container">
          <p>Loading data...</p>
        </div>
      </>
    );
  }

  return (
    <>
      <Header />
      {sellValue === "false" && winnerBool === true && (
        <div className="updatelisting">
          <button onClick={handlePropertyConfirmation}>
            Update Listing Status
          </button>
        </div>
      )}

      <div className="purchase-bid-container scrolleffectx">
        {/* Purchase Request Table */}
        <div className="table-card">
          <h3>Purchase Request Details</h3>
          {purchaseRequests.length > 0 ? (
            <table>
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Name</th>
                  {/* <th>Location</th> */}
                  <th>Value</th>
                  {/* <th>Date</th> */}
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {purchaseRequests.map((item, index) => {
                  // ✅ Check if this request is the winner
                  const isWinner =
                    item.winner === true || item.winner === "true";

                  return (
                    <tr
                      key={index}
                      style={
                        isWinner
                          ? {
                              backgroundColor: "#eaffea", // light green background for winner
                              fontWeight: "bold",
                            }
                          : {}
                      }
                    >
                      <td style={{ width: "58px" }}>
                        <img
                          src={Check}
                          alt=""
                          className="check"
                          style={
                            isWinner
                              ? { display: "inline-block", width: "51%" }
                              : { display: "none" }
                          }
                        />
                        {index + 1}
                      </td>
                      <td>{item.byer?.name || "N/A"}</td>
                      {/* <td>
                        {item.property?.city}, {item.property?.state},{" "}
                        {item.property?.country}
                      </td> */}
                      <td className="amount">
                        ${item.property?.listPrice?.toLocaleString() || "N/A"}
                      </td>
                      {/* <td>{new Date(item.requestedAt).toLocaleDateString()}</td> */}
                      <td>
                        <button
                          className="view-btn"
                          onClick={() => handleViewDetails(item.byer)}
                        >
                          View Details
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <p>No purchase requests found.</p>
          )}
        </div>

        {/* Bidding History Table */}
        <div className="table-card">
          <h3>Offered History</h3>
          {biddingHistory.length > 0 ? (
            <table>
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Bidder</th>
                  <th>Amount</th>
                  {/* <th>Bid Time</th> */}
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {biddingHistory.map((bid, index) => {
                  const isWinner = bid.winner === true || bid.winner === "true";

                  return (
                    <tr
                      key={bid.id}
                      style={
                        isWinner
                          ? {
                              backgroundColor: "#eaffea",
                              fontWeight: "bold",
                            }
                          : {}
                      }
                    >
                      <td style={{ width: "65px" }}>
                        <img
                          src={Check}
                          alt=""
                          className="check"
                          style={
                            isWinner
                              ? { display: "inline-block", width: "51%" }
                              : { display: "none" }
                          }
                        />
                        {String(index + 1).padStart(2, "0")}
                      </td>
                      <td>{bid.byer?.name || "N/A"}</td>
                      <td className="amount">${bid.bidAmount}</td>
                      {/* <td>
                        {new Date(bid.bidTime).toLocaleString("en-IN", {
                          dateStyle: "short",
                          timeStyle: "short",
                        })}
                      </td> */}
                      <td>
                        <button
                          className="view-btn"
                          onClick={() => handleViewDetails(bid.byer)}
                        >
                          View Details
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <p>No bidding history found.</p>
          )}
        </div>
      </div>

      {/* Popup Modal */}
      {showModal && selectedDetails && (
        <div className="modal-overlay">
          <div className="modal-content mklop">
            <h3>Buyer Details</h3>
            <div className="details-box">
              <p>
                <strong>Name:</strong> {selectedDetails.name || "N/A"}
              </p>
              <p>
                <strong>Email:</strong> {selectedDetails.email || "N/A"}
              </p>
              <p>
                <strong>Phone:</strong> {selectedDetails.phone || "N/A"}
              </p>
              <p>
                <strong>SSN:</strong> {selectedDetails.ssn || "N/A"}
              </p>
              <p>
                <strong>Driving Licence:</strong>{" "}
                {selectedDetails.drivingLicence || "N/A"}
              </p>
              <div className="attach-document-box">
                <p className="attach-title">Attach Document</p>
                <div className="attach-content">
                  {selectedDetails.drivingLicenceDoc ? (
                    <a
                      href={selectedDetails.drivingLicenceDoc}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src="https://cdn-icons-png.flaticon.com/512/3767/3767084.png"
                        alt="Folder Icon"
                        className="folder-icon"
                      />
                    </a>
                  ) : (
                    <img
                      src="https://cdn-icons-png.flaticon.com/512/3767/3767084.png"
                      alt="Folder Icon"
                      className="folder-icon"
                    />
                  )}
                </div>
              </div>

              {/* Updated Button */}
              {!(sellValue === "true" || winnerBool === true) && (
                <div className="updatelistingx">
                  <button onClick={handleMarkAsBuyer}>Confirm as Buyer</button>
                </div>
              )}
            </div>

            <button className="close-btn bnjuio" onClick={closeModal}>
              <img src={closed} alt="Close" />
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default PurchaseAndBidding;
